export default "__VITE_ASSET__ae6265cf__"